export const parseParams = (str) => str.split(';').reduce((acc, item) => {
    const [key, value] = item.split('=');
    if (key) {
        acc[key.trim()] = value !== undefined ? value.trim() : true;
    }
    return acc;
}, {});
export const encodeParams = (params) => Object.entries(params)
    .filter(([_, value]) => !!value)
    .map(([key, value]) => `${key}=${value}`)
    .join(';');
//# sourceMappingURL=params.js.map